/**
 * @generated SignedSource<<e7a1feca2839d192cc1104deea5aa7ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MetaAdCallToAction = "CONTACT_US" | "GET_QUOTE" | "LEARN_MORE" | "SHOP_NOW" | "SIGN_UP" | "SUBSCRIBE" | "%future added value";
export type UpdateMetaAdRequest = {
  approved?: boolean | null;
  callToAction?: MetaAdCallToAction | null;
  description?: string | null;
  destinationUrl?: string | null;
  displayUrl?: string | null;
  dominantColor?: string | null;
  facebookPageId?: string | null;
  headline?: string | null;
  id: string;
  instagramAccountId?: string | null;
  metaAdSetIds?: ReadonlyArray<string> | null;
  name?: string | null;
  primaryText?: string | null;
  tags?: ReadonlyArray<string> | null;
};
export type AdPerformanceTableTagsMutation$variables = {
  input: ReadonlyArray<UpdateMetaAdRequest>;
};
export type AdPerformanceTableTagsMutation$data = {
  readonly updateMetaAds: {
    readonly data: ReadonlyArray<{
      readonly id: string;
      readonly tags: ReadonlyArray<string> | null;
    }>;
  };
};
export type AdPerformanceTableTagsMutation = {
  response: AdPerformanceTableTagsMutation$data;
  variables: AdPerformanceTableTagsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PerformanceSummarizedMetaAdList",
    "kind": "LinkedField",
    "name": "updateMetaAds",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PerformanceSummarizedMetaAd",
        "kind": "LinkedField",
        "name": "data",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tags",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AdPerformanceTableTagsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AdPerformanceTableTagsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9db15cdce59ca4886a63a68ff5e07c42",
    "id": null,
    "metadata": {},
    "name": "AdPerformanceTableTagsMutation",
    "operationKind": "mutation",
    "text": "mutation AdPerformanceTableTagsMutation(\n  $input: [UpdateMetaAdRequest!]!\n) {\n  updateMetaAds(input: $input) {\n    data {\n      id\n      tags\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "43c5e23312e6fba9e1f67a931854513b";

export default node;
